var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"group-title-wrapper"},[_c('h2',{staticClass:"group-title"},[_vm._v(_vm._s(_vm.title))]),(_vm.tip)?_c('span',{staticClass:"tip"},[_vm._v(_vm._s(_vm.tip))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }